import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

import { Directive } from '@angular/core';

@Directive({
  selector: '[sharedUtilsDirectiveNoSpecialCharacters]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NoSpecialCharactersDirective,
      multi: true,
    },
  ],
  standalone: true,
})
export class NoSpecialCharactersDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const regex =
      /([\u203C-\u3299]|[\uD83C-\uDBFF][\uDC00-\uDFFF]|\uFE0F|\uD83D[\uDC00-\uDE4F]|[$%&/()=*])/g;
    const forbidden = regex.test(control.value);
    return forbidden ? { noSpecialCharacters: { value: control.value } } : null;
  }
}
